export enum contactInfoType {
    DETAILS = 0,
    CONTACT_LINK = 1,
    NEW_CONTACT = 2,
    DETAILS_EDIT = 3,
    REMOVE_LINK = 4,
    NEW_ENTITY = 5,
    SAVE_ENTITY = 6
}
